import React from 'react';

/**
 * Simple medal/badge icon, used on MyAccount next to the "Business
 * Marketer" status line. Built from scratch — never existed in the
 * project (assumed to be part of an existing icon set, like the Undraw
 * illustrations referenced alongside it).
 */
const MedalIcon = ({ width = 28, height = 28, color = '#e53935' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="9" r="6" fill="#fdd835" stroke={color} strokeWidth="1.5" />
    <path d="M12 6.5l1.1 2.2 2.4.35-1.75 1.7.4 2.4L12 12l-2.15 1.15.4-2.4-1.75-1.7 2.4-.35L12 6.5z" fill={color} />
    <path d="M9 14.5L7 21l5-2.5L17 21l-2-6.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

export default MedalIcon;